import {
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  FormHelperText,
  Box,
  CircularProgress,
} from "@mui/material";

const SelectType = (props) => {
  const {
    label,
    name,
    formik,
    options,
    required,
    role,
    propertyDescription1,
    propertyDescription2,
    ...rest
  } = props;
  const LOADER_SIZE = 20;

  return (
    <Grid>
      <Box
        sx={{
          borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
          paddingLeft: formik.errors[name] ? "16px" : "",
        }}
      >
        <InputLabel
          htmlFor={label}
          sx={{
            textAlign: "left",
            textStyle: "none",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: required ? "bold" : "500",
            }}
          >
            {label}
          </Typography>
          {propertyDescription1 ||
            (propertyDescription2 && (
              <Typography variant="subtitle1" color="light.main">
                {propertyDescription1} <br></br>
                {propertyDescription2}
              </Typography>
            ))}
        </InputLabel>
        <Select
          fullWidth
          sx={{ marginTop: "15px", textAlign: "left", minWidth: 200 }}
          id={label}
          value={name}
          inputProps={{ "aria-label": "Without label" }}
          {...formik.getFieldProps(`${name}`)}
          {...rest}
        >
          {options.map((option) => {
            if (name === "kyepix_office_id" && options.length <= 1 && role) {
              return (
                <MenuItem key={option.value} value={option.value}>
                  {
                    <Box sx={{ display: "flex" }}>
                      <CircularProgress size={LOADER_SIZE} />
                    </Box>
                  }
                </MenuItem>
              );
            }
            return (
              <MenuItem key={option.value} value={option.value}>
                {option.key}
              </MenuItem>
            );
          })}
        </Select>
        {!!formik.errors[name] && (
          <FormHelperText error>
            <Typography
              variant="body1"
              sx={{
                marginTop: "16px",
                fontWeight: "bolder",
              }}
            >
              {formik.errors[name]}
            </Typography>
          </FormHelperText>
        )}
      </Box>
    </Grid>
  );
};

export default SelectType;
